export default "__VITE_ASSET__NQ_xpn$x__"